import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { getClassroomEventTypes } from '../../api';
import { EventTypesResponse } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  EventTypesResponse,
  AxiosResultDefaultError
>();

export function useEventTypes() {
  return useFetch();
}

export const EventTypesConsumer = FetchConsumer;

export function EventTypesLoader({ children }: BaseLoaderProps) {
  const request = useCallback(() => {
    return getClassroomEventTypes();
  }, []);
  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
